import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"chevron\">\n\t<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.3 21.5c.3 0 .5-.1.7-.3l8-8c.4-.4.4-1 0-1.4l-8-8a1 1 0 1 0-1.4 1.4l7.3 7.3-7.3 7.3a1 1 0 0 0 .7 1.7\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol